import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type CurrentAdminService from 'garaje/services/current-admin';
import { GLOBAL_ADMIN, LOCATION_ADMIN } from 'garaje/utils/roles';

const CAN_CONFIGURE_ROLES = [GLOBAL_ADMIN, LOCATION_ADMIN];

export default class WelcomeScreenAbility extends Ability {
  @service declare currentAdmin: CurrentAdminService;

  get canConfigure(): boolean {
    const { roleNames } = this.currentAdmin;
    return CAN_CONFIGURE_ROLES.some((role) => roleNames?.includes(role));
  }
}
